import React from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SubAccounts = ({ members }) => {
    const { t } = useTranslation();
    return (
        <div className="col-md-12">
            <div className="joinings_viewBox" style={{ height: "unset" }}>
                <div className="joinings_viewBox_head">
                    <h5>{t("subAccounts")}</h5>
                </div>
                <div className="">
                    {!members ? (
                        <div className="teammbrs_cnt_row">
                            <div className="teammbrs_cnt_img">
                                <Skeleton
                                    width="45px"
                                    height="45px"
                                    circle
                                    containerClassName="avatar-skeleton"
                                    count={3}
                                />
                            </div>
                            <div className="teammbrs_cnt_name_dtl">
                                <div className="teammbrs_cnt_name">
                                    <Skeleton count={6} />
                                </div>
                            </div>
                        </div>
                    ) : members?.length === 0 ? (
                        <div className="no-data-div">
                            <div className="no-data-div-image">
                                <img src="/images/nodata-image.png" alt="" />
                            </div>
                            <p>{t('noDataFound')}</p>
                        </div>
                    ) : (
                        <div className="row">

                            {members.map((member, index) => (
                                
                                <div className=" col-md-3 text-center mt-2 mb-2" key={index}>
                                        <div className="m-3 p-3 sub-accnt-tile">
                                        <div className="teammbrs_cnt_img" style={{ float: "unset" }}>
                                            <img
                                                src={
                                                    member?.image
                                                        ? member?.image
                                                        : member?.gender === "F"
                                                            ? "/images/team1.png"
                                                            : member?.gender === "M"
                                                                ? "/images/user-profile.png"
                                                                : "/images/team3.png"
                                                }
                                                alt={member?.username}
                                            />
                                        </div>
                                        <div className="teammbrs_cnt_name_dtl">
                                            <div className="teammbrs_cnt_name">
                                                {member.username}
                                            </div>
                                            <div className="teammbrs_cnt_date_id" style={{ display: "unset" }}>
                                                <span>{member?.fullName}</span>
                                                <span>{formatDateWithoutTime(member?.dateOfJoining)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>

                    )}
                </div>

            </div>
        </div>
    );
};

export default SubAccounts;
